import { NgModule } from '@angular/core';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { AnimatedEllipsisComponent } from './AnimatedEllipsisComponent';

@NgModule({
    declarations: [
        AnimatedEllipsisComponent
    ],
    entryComponents: [
        AnimatedEllipsisComponent
    ],
    exports: [
        AnimatedEllipsisComponent
    ]
})
export class AnimatedEllipsisModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            AnimatedEllipsisComponent
        ]);
    }
}
